<template>
    <div class="box">
        <div class="operation">
            <el-form ref="form" :model="form" label-width="80px" class="form" :inline="true">
                <el-form-item label="设备sn号" label-position="right" class="mt">
                    <el-input v-model="form.deviceSn" size="small" placeholder="请输入设备sn号" clearable></el-input>
                </el-form-item>
            </el-form>
            <div class="mt">
                <el-button type="primary" class="btn" @click="queryFunc" icon="el-icon-search">查询</el-button>
                <el-button class="btn" @click="clearFunc" icon="el-icon-delete">重置</el-button>
                <el-button class="primary" @click="getDialogFormVisible(true)" icon="el-icon-delete">导入设备</el-button>
                 <el-button class="btn" icon="el-icon-download" @click="onExport">导出</el-button>
            </div>
        </div>
        <!-- 表格 -->
        <div class="tabBox">
            <el-table v-loading="loading" ref="selections" :data="tableData" tooltip-effect="dark" @selection-change="handleSelectionChange"
                style="width: 100%" border element-loading-text="拼命加载中"
                element-loading-spinner="el-icon-loading" :header-row-style="{ 'font-weight': 'bold', 'color': '#9196A0' }">
                <el-table-column type="selection" width="55" />
                <el-table-column prop="deviceSn" label="设备sn号" width="120" />
                <el-table-column prop="nickName" label="代理名称  " width="120" />
                <el-table-column prop="devImei1" label="国际移动设备识别码" width="140" />
                <el-table-column prop="devImei2" label="国际移动设备识别码" width="140" />
                <el-table-column prop="devMac" label="MAC 地址" width="140" />
                <el-table-column prop="devSwVersion" label="软件版本" width="140" />
                <el-table-column prop="devHwVersion" label="硬件版本" width="140" />
                <el-table-column prop="devMocorSwVersion" label="软件编译版本" />
              <el-table-column label="实名状态" prop="state" width="140">

                <template slot-scope="scope">
                  联通：
                  <span v-if="scope.row.cuccAuthState === 0">未实名</span>
                  <span v-if="scope.row.cuccAuthState === 1">已实名</span>
                  <br>
                  电信：
                  <span v-if="scope.row.ctccAuthState === 0">未实名</span>
                  <span v-if="scope.row.ctccAuthState === 1">已实名</span>
                </template>


              </el-table-column>
                <el-table-column label="状态" prop="state" width="80">
                    <template slot-scope="scope">
                        <span v-if="scope.row.state === 0">初始化</span>
                        <span v-if="scope.row.state === 1">已绑定</span>
                        <span v-if="scope.row.state === 2">已解绑</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="80">
                    <template slot-scope="scope">
                        <el-link v-if="scope.row.state === 1" :underline="false" type="danger" @click="unbind(scope.row)">解绑</el-link>
                      <el-link v-if="scope.row.state === 1" :underline="false" type="primary" @click="showModal(scope.row)">发放套餐</el-link>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!-- 分页 -->
        <div class="paginationBox">
            <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="pageIndex" :page-sizes="[10, 20, 30, 40]" layout="total, sizes, prev, pager, next, jumper"
                :total="total" class="pagination">
            </el-pagination>
        </div>
        <ImportDevice :message="dialogFormVisible" @closeFunction='getDialogFormVisible' @add-success="addSuccess"></ImportDevice>
        <GrantPackage
      v-if="show_grant"
      :show_grant="show_grant"
      :form="checkItem"

      @closeDialog="closeDialogFunc($event)"
    ></GrantPackage>
    </div>
</template>

<script>
import ImportDevice from './components/ImportDevice.vue';
import GrantPackage from './dialog/GrantPackage.vue';
import {getCookie} from '@/utils/base.js';
import WifiApi from '@/api/wifi.js'
import qs from "qs";
export default {
    data() {
        return {
            form: {
                deviceSn: ''
            },
            tableData: [],
            loading: true,
            dialogFormVisible: false,
            total: 0,
            pageSize: 10,
            pageIndex: 1,
            selections: [],
            file: [],
            checkItem:{},
            show_grant:false
        }
    },
    components: { ImportDevice,GrantPackage },
    methods: {
        unbind(row) {
            this.$confirm('确定解绑?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                WifiApi.unBindDevice({
                    deviceId: row.id
                }).then(res => {
                    this.getList();
                })
            })
        },
        showModal(row){
          console.log(row)
          this.checkItem = row
          this.show_grant = true
        },
        closeDialogFunc(){
          this.show_grant = false
          this.queryFunc()
        },
        toggleSelection() {
            this.$refs.selections.clearSelection();
        },
        getDialogFormVisible(flag) {
            this.dialogFormVisible = flag
        },
        handleSelectionChange(val) {
            this.selections = val;
        },
        handleSizeChange(val) {
            this.pageSize = val;
            this.getList();
        },
        handleCurrentChange(val) {
            this.pageIndex = val;
            this.getList();
        },
        // 渲染列表
        getList() {
            this.loading = true;
            const params = {
                deviceSn: this.form.deviceSn,
                pageSize: this.pageSize,
                pageIndex: this.pageIndex,
            }
            WifiApi.deviceList({ ...params }).then(res => {
                this.tableData = res.data.records
                this.total = res.data.total
                this.loading = false;
            }).catch(e => {
                this.loading = false;
            })
        },
        // 查询按钮
        queryFunc() {
            this.pageIndex = 1
            this.getList();
        },
        addSuccess() {
            this.getList()
            this.getDialogFormVisible(false)
        },
        clearFunc() {
            this.pageIndex = 1
            this.form.deviceSn = ''
            this.getList();
        },
        onExport: function() {
            let self = this;
            const Params = {
                deviceSn: this.form.deviceSn,
            }
            Params.token = getCookie('token');
            let baseUrl = window.location.protocol + '//' + window.location.host;
            window.location.href = baseUrl + '/api/shop/iot/device/export?' + qs.stringify(Params);
        },
    },
    mounted() {
        this.getList();
    }
}
</script>

<style scoped>
.mt {
    margin-top: 20px
}

.tabBox {
    margin: 40px 0;
}

.box {
    padding: 10px;
}

.form {
    margin-right: 20px;
}

.btn {
    margin-left: 15px;
    display: inline-block
}

.el-form-item {
    margin-bottom: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/views/ybwifi/device/index.vue